import { useCallback } from 'react';
import {
	FIELD_TYPE_MAP,
	DRAG_DROP_UNKNOWN_FIELD_ID,
} from '@atlassian/jira-issue-analytics/src/services/update-issue-field/constants.tsx';
import { getUpdateAnalyticsFlowHelper } from '@atlassian/jira-issue-analytics/src/services/update-issue-field/index.tsx';
import { SPRINT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { makeIsCardListActiveSprint } from '../../../../state/selectors/sprints/index.tsx';
import { useBacklogSelector } from '../../../../state/index.tsx';
import { getEndAnalyticsSprintActionTaken } from '../../../../common/utils.tsx';
import type { CardId } from '../../../../model/types.tsx';

export const useSprintEndAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const getIsActiveSprint = useBacklogSelector(makeIsCardListActiveSprint);

	const fireEndEvent = useCallback(
		(
			selectedCards: CardId[],
			sourceCardListId: string | undefined,
			destinationCardListId: string,
		) => {
			if (selectedCards.length !== 1) {
				return;
			}

			const actionTaken = getEndAnalyticsSprintActionTaken(sourceCardListId, destinationCardListId);
			if (!actionTaken) {
				getUpdateAnalyticsFlowHelper().fireAnalyticsEnd(DRAG_DROP_UNKNOWN_FIELD_ID, {
					analytics: createAnalyticsEvent({}),
					attributes: {
						fieldType: SPRINT_TYPE,
						fieldKey: FIELD_TYPE_MAP[SPRINT_TYPE],
						hasRankChanged: true,
						isDragEditing: true,
					},
				});
				return;
			}

			const isToActiveSprint = getIsActiveSprint(destinationCardListId);
			const isFromActiveSprint = getIsActiveSprint(sourceCardListId || '');

			if (isFromActiveSprint || isToActiveSprint) {
				// end analytics will fire at modal confirm
				return;
			}

			getUpdateAnalyticsFlowHelper().fireAnalyticsEnd(DRAG_DROP_UNKNOWN_FIELD_ID, {
				analytics: createAnalyticsEvent({}),
				attributes: {
					fieldKey: FIELD_TYPE_MAP[SPRINT_TYPE],
					fieldType: SPRINT_TYPE,
					isDragEditing: true,
					actionTaken,
				},
			});
		},
		[createAnalyticsEvent, getIsActiveSprint],
	);

	return { fireEndEvent };
};
